import { createSelector } from 'reselect';

const getMetaData = (
  state: import('../types/rootState').RootState
): import('../types/metadata').MetaData | undefined => state.metaData;

const getSisFlag = createSelector(getMetaData, metaData => !!metaData?.sis);

const getCurrentStore = createSelector(getMetaData, metaData => metaData?.name || '');

const getSisStores = createSelector(getMetaData, metaData => metaData?.stores || []);

const getSisNavigation = createSelector(
  getMetaData,
  metaData => metaData?.current?.navigation?.childDetails
);

const getSisStyles = createSelector(getMetaData, metaData => {
  const current = metaData?.current;
  if (current) {
    const {
      colorTheme = '#fff',
      textColor = '#000',
      headerIconColor = '#000',
      smallerLogo = '',
      subdomain = '',
      appPopupLogo = '',
      biggerLogo = ''
    } = current;
    return {
      colorTheme,
      textColor,
      headerIconColor,
      smallerLogo,
      subdomain,
      appPopupLogo,
      biggerLogo
    };
  }
  return {};
});

export { getSisFlag, getSisNavigation, getSisStyles, getSisStores, getCurrentStore };
